import { render, staticRenderFns } from "./quesGuide5.vue?vue&type=template&id=6231951f"
import script from "./quesGuide5.vue?vue&type=script&lang=js"
export * from "./quesGuide5.vue?vue&type=script&lang=js"
import style0 from "./quesGuide5.vue?vue&type=style&index=0&id=6231951f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports